import { create } from "zustand";

export const useMetadataEditorNavigationStore = create<{
  tab: string;
  format: string | null;
  setTab: (tab: string) => void;
  openFormat: (format: string) => void;
}>(set => ({
  tab: "elements",
  format: null,
  setTab: tab => set({ tab, format: null }),
  openFormat: format => set({ tab: "formats", format }),
}));
